import { makeVar } from '@apollo/client';

export const inChangesetVar = makeVar<boolean>(false);
